function defaultKeyExtractor(item: object): string {
    if (typeof item === 'object' && 'key' in item && typeof item.key === 'string') {
        return item.key;
    }
    throw new Error("Cannot extract key from item: item must be an object with a 'key' property");
}

export function sortByOrder<T extends object>(
    collection: T[],
    orderedKeys: string[],
    keyExtractor: (item: T) => string = defaultKeyExtractor,
): T[] {
    if (!collection || !orderedKeys) {
        return collection || [];
    }

    return [...collection].sort((a, b) => {
        const keyA = keyExtractor(a);
        const keyB = keyExtractor(b);
        const indexA = orderedKeys.indexOf(keyA);
        const indexB = orderedKeys.indexOf(keyB);

        if (indexA >= 0 && indexB >= 0) {
            // if both items are in the order list, sort by position
            return indexA - indexB;
        } else if (indexA >= 0) {
            // if only indexA is in orderedKeys, prioritize it
            return -1;
        } else if (indexB >= 0) {
            // if only indexB is in orderedKeys, prioritize it
            return 1;
        } else {
            // else maintain order
            return 0;
        }
    });
}
